/* eslint-disable prettier/prettier */
export default {
  generate(): string {
    return `${1e7}${-1e3}${-4e3}${-8e3}${-1e11}`.replace(/[018]/g, c => {
      const randomValues = window.crypto.getRandomValues(new Uint8Array(1))
      const numericValue = Number(c)
      // eslint-disable-next-line no-bitwise
      return (numericValue ^ (randomValues[0] & (15 >> (numericValue / 4)))).toString(16)
    })
  }
}
